import { EmployeeNodeModel } from '../../models/groupedEmployee.model';
import { getChildNodes, getDatesBetweenDates } from '../../utils';

interface Props {
    grid: any;
    startDate: string;
    endDate: string;
    treeEmployees: EmployeeNodeModel[];
    openAidTypesModal: (date: string, employee: EmployeeNodeModel) => void;
}

export const controllerAidTypesModal = ({
    grid,
    treeEmployees,
    startDate,
    endDate,
    openAidTypesModal,
}: Props) => {
    let row1 = grid.selectedRanges[0].row;
    let row2 = grid.selectedRanges[0].row2;
    let col1 = grid.selectedRanges[0].col - 2;
    let col2 = grid.selectedRanges[0].col2 - 2;

    if (row1 > row2) {
        let aux = row1;
        row1 = row2;
        row2 = aux;
    }

    if (col1 > col2) {
        let aux = col1;
        col1 = col2;
        col2 = aux;
    }

    let initDate = getDatesBetweenDates(startDate, endDate)[col1];
    let lastDate = getDatesBetweenDates(startDate, endDate)[col2];

    if (initDate === lastDate) {
        let selectedEmployee = getChildNodes(treeEmployees).slice(row1, row2 + 1);
        openAidTypesModal(initDate, selectedEmployee[0]);
    }
};
